import React from 'react';

function VMConsolePanel({
  consoleReconnecting,
  consoleConnecting,
  consoleError,
  pasteOpen,
  pasteText,
  consoleFocused,
  displayRef,
  onPasteTextChange,
  onPasteOpenChange,
  onInjectShiftInsert,
  onInjectKeystrokes,
  onInjectClipboard,
}) {
  return (
    <div className="vnc-panel">
      {consoleReconnecting && (
        <div className="vnc-reconnecting">
          <span className="vnc-reconnecting-spinner">⟳</span>
          Aguardando VM reiniciar... reconectando automaticamente
        </div>
      )}
      {!consoleReconnecting && consoleConnecting && (
        <div className="vnc-connecting">Conectando ao console VNC...</div>
      )}
      {consoleError && (
        <div className="vnc-error">{consoleError}</div>
      )}
      {pasteOpen && (
        <div className="vnc-paste-bar">
          <input
            type="text"
            className="vnc-paste-input"
            placeholder="Cole ou escreva o texto aqui..."
            value={pasteText}
            onChange={e => onPasteTextChange(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') { e.preventDefault(); onInjectShiftInsert(pasteText); }
              if (e.key === 'Escape') { onPasteOpenChange(false); onPasteTextChange(''); }
            }}
            autoFocus
          />
          <div className="vnc-paste-actions">
            <button className="vnc-paste-btn primary" onClick={() => onInjectKeystrokes(pasteText)} disabled={!pasteText} title="Injeta tecla a tecla — funciona em qualquer VM.">
              ⌨ Colar
            </button>
            <button className="vnc-paste-btn send-win" onClick={() => onInjectClipboard(pasteText, true)} disabled={!pasteText} title="Clipboard VNC + Ctrl+V (requer suporte a clipboard na VM)">
              Ctrl+V
            </button>
            <button className="vnc-paste-btn cancel" onClick={() => { onPasteOpenChange(false); onPasteTextChange(''); }} title="Fechar (Esc)">✕</button>
          </div>
        </div>
      )}
      <div
        className={`vnc-focus-bar ${consoleFocused ? 'focused' : 'unfocused'}`}
        onClick={() => { displayRef.current?.querySelector('canvas')?.click(); }}
        title={consoleFocused ? 'Teclado capturado pela VM' : 'Clique na tela para capturar o teclado'}
      >
        {consoleFocused
          ? <><span className="vnc-focus-dot focused" />Teclado capturado — digitação vai para a VM</>
          : <><span className="vnc-focus-dot unfocused" />Clique na tela para digitar</>
        }
      </div>
      <div className="vnc-display" ref={displayRef} />
    </div>
  );
}

export default VMConsolePanel;
